import { PrincipalSubscriptionV2 } from '../../model/v2/EntitiesV2';
import dateService from '../../services/DateService';
import apiAxiosV2 from './CustomAxiosV2';

class PrincipalApiV2 {
    getCurrentSubscription = async (): Promise<PrincipalSubscriptionV2> => {
        const response = await apiAxiosV2.get<PrincipalSubscriptionV2>(`/principals/current/subscription`);
        this.loadDates(response.data);

        return response.data;
    };

    /**
     * Loads the dates of a principal subscription.
     * @param trap - the principal subscription
     */
    private loadDates(principalSubscription: PrincipalSubscriptionV2) {
        principalSubscription.subscriptionPaid = dateService.transformDate(principalSubscription.subscriptionPaid);
        principalSubscription.subscriptionExpired = dateService.transformDate(
            principalSubscription.subscriptionExpired,
        );
    }
}

const principalApiV2: PrincipalApiV2 = new PrincipalApiV2();
export default principalApiV2;
